type Unit = {
  value: number
  themeValue: number
  valueWithUnit: string
}

export function pxTorem(value: number, base = 16): Unit {
  const remValue = value / base
  const remValueWithUnit = `${remValue}rem`

  return {
    value: remValue,
    themeValue: value / 4,
    valueWithUnit: remValueWithUnit
  }
}

export function remTopx(value: number, base = 16): Unit {
  const pxValue = value * base
  const pxValueWithUnit = `${pxValue}px`

  return {
    value: pxValue,
    themeValue: value * 4,
    valueWithUnit: pxValueWithUnit
  }
}
